import React from "react";
import {
  Button,
  Table,
  TableContainer,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Chip
} from "@material-ui/core";
import useStyles from "./styles";

const states = {
  done: "success",
  processing: "warning",
  declined: "secondary",
};

const KEY_ARRAY= ['ID', 'Status', 'DownloadURL', 'Voice', 'Language', 'Engine', 'CreatedAt', 'UpdatedAt'];

export default function TableComponent({ data }) {

  const classes = useStyles();
  if(!Array.isArray(data) || !data.length || !data[0]) {
    return (null);
  }

  const sortedData = data.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

  return (
    <TableContainer>
      <Table className="mb-0">
      <TableHead>
        <TableRow>
          {KEY_ARRAY.map(key => (
            <TableCell style={{
            }} key={key}>{key}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {sortedData.map((element) => {
          let { id, voice, url, status, languageCode, engine, createdAt, updatedAt} = element;
          return (
          <TableRow key={id}>
            <TableCell className="pl-3 fw-normal">{id}</TableCell>
            <TableCell>
              <Chip label={status} classes={{root: classes[states[status.toLowerCase()]]}}/>
            </TableCell>
            <TableCell>
              {
                url ?
                <Button
                  target="_blank"
                  href={url}
                  color="primary"
                  variant="contained"
                >
                  Download
                </Button> :
                <Button
                  disabled
                  variant="contained"
                >
                  Not Available
                </Button>
              }
            </TableCell>
            <TableCell>{voice}</TableCell>
            <TableCell>{languageCode}</TableCell>
            <TableCell>{engine}</TableCell>
            <TableCell>{createdAt}</TableCell>
            <TableCell>{updatedAt}</TableCell>
          </TableRow>
          )
        })}
      </TableBody>
    </Table>
    </TableContainer>

  );
}
